import type { FlowNode } from '@lighthouse/shared'
import { type LoopNodeActionConfig, nodeTypeIconMap, useAtomData } from '@lighthouse/shared'
import { useNodesData } from '@xyflow/react'
import React, { useCallback, useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'

import * as CM from '../styles'
import * as SC from './styles'

type LoopCardProps = {
    config: LoopNodeActionConfig
}

const LoopCard: React.FC<LoopCardProps> = ({ config }) => {
    const nodeId = config.loopType === 'BASE_ON_RECORDS' ? config.recordsConfig?.nodeId : undefined

    //   const { start, end, step, subProcessId } = timesConfig || {};
    const node = useNodesData(nodeId || '') as FlowNode
    const workflows = useAtomData(
        workflowListAtom,
        useCallback(draft => draft.map(item => ({ id: item.id, name: item.name })), [])
    )

    return useMemo(() => {
        if (config.loopType === 'BASE_ON_TIMES') {
            const { start, end, step, subProcessId } = config.timesConfig || {}
            const subProcess = workflows.find(item => item.id === subProcessId)
            return (
                <CM.CardContainer>
                    <CM.CardItemContainer>
                        <SC.TypeName>按指定循环次数</SC.TypeName>

                        <SC.FieldList>
                            <SC.FieldItem>
                                <SC.FieldItemTitle>起始值</SC.FieldItemTitle>
                                <SC.FieldItemRightTitle>
                                    {start?.type === 'VALUE' && start.valueVariable && String(start.valueVariable.value)}
                                </SC.FieldItemRightTitle>
                            </SC.FieldItem>

                            <SC.FieldItem>
                                <SC.FieldItemTitle>结束值</SC.FieldItemTitle>
                                <SC.FieldItemRightTitle>
                                    {end?.type === 'VALUE' && end.valueVariable && String(end.valueVariable.value)}
                                </SC.FieldItemRightTitle>
                            </SC.FieldItem>

                            <SC.FieldItem>
                                <SC.FieldItemTitle>步长</SC.FieldItemTitle>
                                <SC.FieldItemRightTitle>
                                    {step?.type === 'VALUE' && step.valueVariable && String(step.valueVariable.value)}
                                </SC.FieldItemRightTitle>
                            </SC.FieldItem>
                        </SC.FieldList>
                    </CM.CardItemContainer>

                    {subProcess && (
                        <CM.CardItemContainer>
                            <SC.TypeName>循环到子流程</SC.TypeName>

                            <SC.FieldList>
                                <SC.FieldItem left>
                                    <SC.FieldItemIcon>
                                        <SC.Icon type="Reorder" />
                                    </SC.FieldItemIcon>
                                    <SC.FieldItemRightTitle>{subProcess.name}</SC.FieldItemRightTitle>
                                </SC.FieldItem>
                            </SC.FieldList>
                        </CM.CardItemContainer>
                    )}
                </CM.CardContainer>
            )
        }
        const { subProcessId } = config.recordsConfig || {}
        const subProcess = workflows.find(item => item.id === subProcessId)
        return (
            <CM.CardContainer>
                {node && (
                    <CM.CardItemContainer>
                        <SC.TypeName>按查询到的记录循环</SC.TypeName>
                        <SC.FieldItem left>
                            <SC.FieldItemIcon>
                                <SC.Icon type={nodeTypeIconMap[node.data.nodeType]} />
                            </SC.FieldItemIcon>
                            <SC.FieldItemRightTitle>{node.data.name}</SC.FieldItemRightTitle>
                        </SC.FieldItem>
                    </CM.CardItemContainer>
                )}
                {subProcess && (
                    <CM.CardItemContainer>
                        <SC.TypeName>循环到子流程</SC.TypeName>
                        <SC.FieldList>
                            <SC.FieldItem left>
                                <SC.FieldItemIcon>
                                    <SC.Icon type="Reorder" />
                                </SC.FieldItemIcon>
                                <SC.FieldItemRightTitle>{subProcess.name}</SC.FieldItemRightTitle>
                            </SC.FieldItem>
                        </SC.FieldList>
                    </CM.CardItemContainer>
                )}
            </CM.CardContainer>
        )
    }, [config, node, workflows])
}

export default LoopCard
